import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import CheckboxListControl from '../Fields/CheckboxListControl';
import TextboxControl from '../Fields/TextboxControl';
import Translate from '../Translate';
import { IFilterProps } from './Interfaces';

const Filter: React.FC<IFilterProps> = ({ colInfo, colUserSettings, colIndex, menuWidth, menuHight, menuLeft, menuTop, onChangeFilter, hideFilter }) => {
    const [checkAllValue, setCheckAllValue] = useState<string[]>();
    const [maxHeight, setMaxHeight] = useState(menuHight)
    const [top, setTop] = useState(menuTop)


    const targetRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (colUserSettings.visible) {
            if (colInfo.filterInfo?.filterOptions?.length === colUserSettings.selectedFilterValues?.length) {
                setCheckAllValue(() => ["All"])
            }
        }

        // eslint-disable-next-line
    }, [colUserSettings])

    useEffect(() => {
        if (targetRef.current) {
            let rect = targetRef.current.getBoundingClientRect()
            console.log(rect)
            const windowOuterHeight = window.outerHeight
            const windowInnerHeight = window.innerHeight
            const screenHeight = screen.height

            let newHeight = rect.height + menuTop
            let newTop = menuTop - newHeight

            let exactNewTop = rect.top - menuTop + newTop
            if (exactNewTop < 0) {
                newHeight = newHeight + exactNewTop
                newTop = -1 * rect.top
            }

            //setMaxHeight(newHeight)
            //setTop(newTop)
        }
    }, [targetRef.current])

    function onChange(val) {
        if (colInfo.filterInfo?.filterOptions) {
            let filterOptions = Array.from(colInfo.filterInfo?.filterOptions, (x) => x.value);
            if (filterOptions.length === val.length)
                setCheckAllValue(() => ["All"])
            else
                setCheckAllValue(() => [])

        }
        if (Array.isArray(val)) {
            onChangeFilter(colIndex, val);
        }
        else {
            onChangeFilter(colIndex, [val]);
        }
    }

    function onSelectAll(val) {
        if (val.length > 0 && colInfo.filterInfo?.filterOptions) {
            setCheckAllValue(() => ["All"])
            val = Array.from(colInfo.filterInfo?.filterOptions, (x) => x.value);
            onChangeFilter(colIndex, val);
        } else {
            setCheckAllValue(() => [])
            onChangeFilter(colIndex, []);
        }
    }

    function getFilterControl(fieldType: 'Textbox' | 'CheckboxList' | undefined) {
        switch (fieldType) {
            case 'Textbox':
                return <TextboxControl
                    name={'filter_' + colInfo.title}
                    width={menuWidth}
                    value={colUserSettings.selectedFilterValues}
                    validationResults={[]}
                    onChange={onChange}
                />
            case 'CheckboxList':
                return <CheckboxListControl
                    name={'filter_' + colInfo.title}
                    width={menuWidth}
                    value={colUserSettings.selectedFilterValues}
                    validationResults={[]}
                    onChange={onChange}
                    options={colInfo.filterInfo?.filterOptions}
                    layout='vertical'
                />
        }
    }

    function getSelectAllCheckbox() {
        return <CheckboxListControl
            name='filter_All'
            width={menuWidth}
            value={checkAllValue}
            validationResults={[]}
            onChange={onSelectAll}
            options={[{ "value": "All", "label": "All" }]}
            layout='vertical'
        />
    }

    let activeClassNameForFilter = ''
    let values = colInfo.filterInfo?.filterValues

    if (values && ((colInfo.filterInfo?.filterType === 'CheckboxList' && values.length > 0) || (values.length === 1 && values[0] !== '')))
        activeClassNameForFilter = 'active'

    return (
        <div ref={targetRef} className='filter-menu' style={{ left: menuLeft ? menuLeft : 0, top: top, width: menuWidth + 22 }}>
            <div className='filter-menu-header'>
                <div className='pull-left' style={{ padding: 5 }}><Translate context='dt'>Filter</Translate> {colInfo.title}</div>
                <div className='pull-right'><Button type='button' className='btn-close' onClick={hideFilter} /></div>
            </div>
            <div className='filter-menu-body' style={{ maxHeight: maxHeight ? maxHeight : 'none', overflowY: maxHeight ? 'auto' : 'unset', overflowX: maxHeight ? 'hidden' : 'unset' }}>
                {colInfo.filterInfo?.filterType === "CheckboxList" && getSelectAllCheckbox()}
                {getFilterControl(colInfo.filterInfo?.filterType)}
            </div>
        </div>
    );
}
export default Filter;
